import React, { createContext, useContext, useEffect, useState } from 'react';

const ClimateContext = createContext({
    climate: 'snowy',
    month: 12,
    temperature: 0,
    conditions: '',
});

export const useClimate = () => {
    const context = useContext(ClimateContext);
    if (!context) {
        throw new Error('useClimate must be used within a ClimateProvider');
    }
    return context;
};

// Determine climate based on month
const getClimateFromMonth = (month) => {
    // Winter: December (12), January (1), February (2)
    if (month === 12 || month === 1 || month === 2) {
        return {
            climate: 'snowy',
            conditions: 'Snowing',
            temperature: -5,
            tempUnit: '°C'
        };
    }

    // Spring: March (3), April (4), May (5)
    if (month >= 3 && month <= 5) {
        return {
            climate: 'sunny',
            conditions: 'Sunny',
            temperature: 28,
            tempUnit: '°C'
        };
    }

    // Summer/Monsoon: June (6), July (7), August (8)
    if (month >= 6 && month <= 8) {
        return {
            climate: 'rainy',
            conditions: 'Rainy',
            temperature: 25,
            tempUnit: '°C'
        };
    }

    // Autumn: September (9), October (10), November (11)
    return {
        climate: 'windy',
        conditions: 'Windy',
        temperature: 20,
        tempUnit: '°C'
    };
};

export const ClimateProvider = ({ children }) => {
    const [climateData, setClimateData] = useState(() => {
        const now = new Date();
        const month = now.getMonth() + 1; // getMonth() returns 0-11, we need 1-12
        return {
            month,
            ...getClimateFromMonth(month)
        };
    });

    // Update climate if month changes (check every hour)
    useEffect(() => {
        const checkMonth = () => {
            const now = new Date();
            const currentMonth = now.getMonth() + 1;

            if (currentMonth !== climateData.month) {
                setClimateData({
                    month: currentMonth,
                    ...getClimateFromMonth(currentMonth)
                });
            }
        };

        // Check every hour
        const interval = setInterval(checkMonth, 1000 * 60 * 60);

        return () => clearInterval(interval);
    }, [climateData.month]);

    return (
        <ClimateContext.Provider value={climateData}>
            {children}
        </ClimateContext.Provider>
    );
};
